import axios from "../../axiosClient";

export const getLocationBlockByCode = async (blockCode: any, signal: any) => {
  const res = await axios.get(`/slpapp/Dashboard/getBlockByBlockCode`, {
    params: { blockCode },
    signal,
  });

  return res?.data?.data;
};

export const getBlockStatusByBlockCode = async (
  blockCode: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/BlockStatus/byBlockCode`, {
    params: { blockCode },
    signal,
  });

  return res?.data?.data;
};

export const getLuminaryStatusByBlockCode = async (
  blockCode: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/Block/luminaryStatusByBlockCode`, {
    params: { blockCode },
    signal,
  });

  return res?.data?.data;
};

export const getEquipmentQuantityByBlockCode = async (
  blockCode: any,
  signal: any
) => {
  const res = await axios.get(
    `/slpapp/Dashboard/getEquipmentQuantityByBlockCode`,
    {
      params: { blockcode: blockCode },
      signal,
    }
  );

  return res?.data;
};

export const getGatewaysByBlockCode = async (
  blockCode: any,
  PageNumber: any,
  pageSize: any,
  signal: any,
  SortBy?: any,
  SortDirection?: any
) => {
  if (!blockCode) return;
  const res = await axios.get(`/slpapp/Block/gatewaysByBlockCode`, {
    params: { blockCode, PageNumber, pageSize, SortBy, SortDirection },
    signal,
  });

  return res?.data;
};

export const getSitesByTcCodeService = async (tcCode: any, signal: any) => {
  if (!tcCode) return [];

  const res = await axios.get(`/slpapp/Site/byTCcode`, {
    params: { tcCode },
    signal,
  });

  return res?.data?.data;
};

export const getBlocksBySiteCodeService = async (
  siteCode: any,
  signal: any
) => {
  if (!siteCode) return [];

  const res = await axios.get(`/slpapp/Block/bySiteCode`, {
    params: { siteCode },
    signal,
  });

  return res?.data?.data;
};

export const getAssetsByBlockService = async (
  blockCode: any,
  level: any,
  signal: any,
  page: number = 1,
  pageSize: number = 15,
) => {
  if (!blockCode || level?.length == 0) return;

  const res = await axios.get(`/slpapp/Asset/AssetsByBlock`, {
    params: { blockCode, level, PageNumber: page, pageSize },
    signal,
  });

  return res?.data?.data;
};

export const getAssetsByBlockLevelAndTypeService = async (
  blockCode: any,
  level: any,
  assetType: any,
  signal: any,
  page: number = 1,
  pageSize: number = 15,
  SortBy?: any,
  SortDirection?: any,
) => {
  if (!blockCode || !assetType) return;

  const res = await axios.get(`/slpapp/Asset/AssetsByBlockLevelAndType`, {
    params: {
      blockCode,
      ...(level ? { level } : {}),
      assetType,
      PageNumber: page,
      PageSize: pageSize,
      SortBy,
      SortDirection,
    },
    signal,
  });

  return res?.data;
};

export const getAssetsByBlockWithSupplierId = async (
  blockCode: any,
  supplierId: any,
  signal: any
) => {
  if (!blockCode || !supplierId) return;

  const res = await axios.get(`/slpapp/Asset/AssetsByBlockWithSupplierId`, {
    params: { blockCode, supplierId },
    signal,
  });

  return res?.data?.data;
};

export const getLevelsByBlockCode = async (blockCode: any, signal: any) => {
  if (!blockCode) return [];

  const res = await axios.get(`/slpapp/AssetDisplayLevel/GetAllDisplayLevelByBlock`, {
    params: { blockCode },
    signal,
  });

  return res?.data?.data;
};
